// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2697":"234236e666e0b64f","7553":"17e559fbe60603e6","8378":"f82b93ae22688ae2"}[chunkId] + ".css";
};